const ERROR_MESSAGE_TRANSLATIONS: Record<string, string> = {
  'Invalid email': 'E-mail inválido',
  'Invalid telephone number': 'Telefone inválido',
  'Invalid business type': 'Modelo de negócio inválido',
};

export const DEFAULT_INSTALLATION_ERROR_MESSAGE = 'Erro ao criar instalação';

export default function getInstallationErrorMessage(message?: string): string {
  if (!message) return DEFAULT_INSTALLATION_ERROR_MESSAGE;
  return ERROR_MESSAGE_TRANSLATIONS[message] ?? message;
}
